import React, { useEffect, useRef, useState } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { MdOutlineMailOutline } from "react-icons/md";
import { BsXLg } from "react-icons/bs";
import { getAutodropTime, millisecondsToSeconds } from '../../../utils/utils';
import { useNavigate } from 'react-router-dom';
import { chatSliceAction } from '../../../store/chatSlice';


const IncomingEmailPopup = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const timerRef = useRef<any>(null);
	const contactObj = useSelector((state:any)=>{return state.contactSlice.EmailContactObject})
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
	const [isDisabled, setIsDisabled] = useState<any>(false)
	const [isAcceptDisabled, setIsAcceptDisabled] = useState<any>(false)
	const [isRejectDisabled, setIsRejectDisabled] = useState<any>(false)
	const [popupStatus, setPopupStatus] = useState<any>(false);
	const [queueName, setQueueName] = useState<any>("")
	const [contactAttributes, setContactAttributes] = useState<any>({})
	const [autodropTimeState, setAutodropTimeState] = useState(0);
	const [show, setShow] = useState(false);
	
	useEffect(() => {
		if(agentObj && contactObj) {
			try {
				let connectionStatus = contactObj?.getStatus().type
				let isEmail = contactObj?.getAttributes()?.ChannelTwo?.value || '';
				if(connectionStatus === 'connecting' && isEmail === 'Email') {
					setShow(true)
					setPopupStatus(true)
					setQueueName(contactObj.getQueue())
					setContactAttributes(contactObj?.getAttributes())
					/*timerRef.current = setInterval(() => {
						try {
							let autodropTime = getAutodropTime(contactObj?.getQueue()?.name, contactObj?.getType())
							let contactDirection = contactObj?.getAttributes()?.Direction?.value;
							if(contactObj.getState().type === 'connecting' && autodropTime > 0 && contactDirection === "INBOUND") {
								let callDuration = millisecondsToSeconds(contactObj?.getStatusDuration())
								let remainTime = autodropTime - callDuration
								if(remainTime > 0) {
									setAutodropTimeState(autodropTime - callDuration)
								} else {
									setIsDisabled(false)
									setIsAcceptDisabled(false)
									setIsRejectDisabled(false)
									dispatch(chatSliceAction.changeisEmailRejected({isEmailRejected: true}));
									dispatch(chatSliceAction.changeisItEmail({isItEmail:true}));
									dispatch(chatSliceAction.changeNewIncomingEmail({newIncomingEmail: false}));
									contactObj?.getAgentConnection().destroy();
								}
							}
						} catch (err) {
							console.log(err)
							clearInterval(timerRef.current)
						}
					}, 1000)*/
				}
				
				contactObj?.onRefresh(() => {
					let connectionStatus = contactObj?.getStatus().type
					if(connectionStatus !== 'connecting' && isEmail === 'Email') {
						setPopupStatus(false)
						setQueueName(contactObj.getQueue())
						setContactAttributes(contactObj?.getAttributes())
					}
				})
				
			} catch (err) {
				console.log(err)
				clearInterval(timerRef.current)
			}
		}
		return () => clearTimeout(timerRef.current);
	},[agentObj, contactObj])

	const handleClose = () => {
		setIsDisabled(false)
		setIsAcceptDisabled(false)
		setIsRejectDisabled(false)
		popupStatus(false)
		setShow(false)
	};

	const onAcceptCall = async () => {
		setIsAcceptDisabled(true)
		setIsDisabled(true)
		await contactObj.accept({
			success:function(){
				setIsDisabled(false)
				setIsAcceptDisabled(false)
				setIsRejectDisabled(false)
				dispatch(chatSliceAction.changeNewIncomingEmail({newIncomingEmail: false}));
				console.log("ConnectionComponent::onAcceptCall::Call Accepted Succesfully");				
				navigate("/email")
			},
			failuer:function(err:any){
				console.log("ConnectionComponent::onAcceptCall::Error in Call Accept"+err);				
			}
        })
    }

    const onRejectCall = () =>{
		setIsDisabled(true)
		setIsRejectDisabled(true)
        contactObj.reject({
            success:function(){
				setIsDisabled(false)
				setIsAcceptDisabled(false)
				setIsRejectDisabled(false)
				dispatch(chatSliceAction.changeisEmailRejected({isEmailRejected: true}));
				dispatch(chatSliceAction.changeisItEmail({isItEmail:true}));
				dispatch(chatSliceAction.changeisEmailMissed({isEmailMissed: true}));
                dispatch(chatSliceAction.changeNewIncomingEmail({newIncomingEmail: false}));
				console.log("ConnectionComponent::onRejectCall::Call Rejected Succesfully");				
			},
			failuer:function(err:any){
				console.log("ConnectionComponent::onRejectCall::Error in Call Reject"+err);				
			}
        })
    }
    

	//{autodropTimeState > 0 && <label className='text-danger'><strong>Email will autodrop in {autodropTimeState} seconds</strong></label>}
	return (
        <React.Fragment>
			{(popupStatus) &&
				<Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} centered>
					<Modal.Header className='dailpad-header'>
						<Modal.Title className='text-darkblue'>Alert</Modal.Title>
						<button className='close-btn-x' onClick={handleClose}>
							<BsXLg/>
						</button>
					</Modal.Header>
					<Modal.Body>
						<div className='row'>
							<div className='col-12'>
								<div className='incomming-box text-center'>
									
									<div className='incomming-call-icon text-success'><MdOutlineMailOutline /></div>
									<h6 className='mt-3 mb-0 text-darkblue'>Incoming email</h6>
									<h4 className='fw-bold text-darkblue'>{contactAttributes.Sender.value || ''}</h4>   
									<h6 className='mt-4 mb-0 text-darkblue'>Language - {contactAttributes.Language.value || ''}</h6>
									<h6 className='text-darkblue'>{ queueName?.name || "" }</h6>     
									{
										contactAttributes?.Account?.value && <h6 className='text-darkblue'>Account: {contactAttributes?.Account?.value || ""}</h6>
									}


									{
										contactAttributes?.AccountName?.value &&
										<h6 className='text-darkblue'>Account Name: {contactAttributes?.AccountName?.value || ""}</h6>
									}

									{
										contactAttributes?.Site?.value &&
										<h6 className='text-darkblue'>Site: {contactAttributes?.Site?.value || ""}</h6>
									}

									{
										contactAttributes?.ServiceType?.value &&
										<h6 className='text-darkblue'>Service Type: {contactAttributes?.ServiceType?.value || ""}</h6>
									}

									{contactAttributes?.QueueNames?.value &&
										<h6 className='text-darkblue'>Queue Names: {contactAttributes?.QueueNames?.value || ""}</h6>

									}          
								</div>                    
							</div>
						</div>
						<div className='row'>
							<div className='col-12 text-center'>
								<Button disabled={isDisabled} onClick={()=>{ onAcceptCall() }} className='mw-100 me-2' variant="primary"> 
									{isAcceptDisabled && <Spinner as="span"animation="grow" size="sm" role="status" aria-hidden="true"/>} Accept
								</Button>
								<Button disabled={isDisabled} onClick={()=>{ onRejectCall() }} className='mw-100' variant="danger">
									{isRejectDisabled && <Spinner as="span"animation="grow" size="sm" role="status" aria-hidden="true"/>} Decline
								</Button>
							</div>
						</div>
					</Modal.Body>
				</Modal>
			}
		</React.Fragment>                 
    )
}
export default IncomingEmailPopup;